<template>
	<div class="study">
		<publicHeader></publicHeader>
		<careerHeader :careerNav ="careerNav"></careerHeader>
		<div class="major w1200">
			<div class="flex famous_position">
				<div class="my_position_l cl_gray">
					<img src="../../../static/icon_position.png" class="mar5" />
					<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/career" class="cl_gray">生涯规划</router-link>
					  >  <router-link to="/treasury" class="cl_gray">生涯宝库</router-link>  >  专业信息库</p>
				</div>
			</div>
			<div class="major_uni f18px cl_dark">
				<div class="major_ui_list" v-for="(item,index) in majorCate" :key="item.id" :class="{'on':index==currenCate}" @click="uniCheck(index)">{{item.name}}</div>
			</div>
			<div class="college">
				<div class="college_nav f16px cl_gray tc">
					<div class="college_nav_list bg_gray radius20" v-for="(item,index) in collegeList" :key="item.id" :class="{'on':index==currenCollege}"
					 @click="collCheck(index)">{{item.name}}</div>
				</div>
				<div class="college_cont mat40" v-if="collegeList.length != 0">
					<div class="college_title f26px">{{collegeList[currenCollege].name}}</div>
					<div class="college_mid mat20">
						<img :src="collegeList[currenCollege].pic" class="college_mid_img" />
						<div class="college_mid_text f18px cl_dark">
							<p>{{collegeList[currenCollege].intro_1}}</p>
							<p class="mat10">{{collegeList[currenCollege].intro_2}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="major_cont">
				<div class="major_item" v-for="(item,index) in majorCont" :key="index">
					<div class="major_item_title f20px cl_dark">{{item.name}}</div>
					<div class="major_item_cont">
						<div v-for="item in item.major_data" :key="item.id" class="major_item_list mab20">
							<router-link :to="{ path: '/treasury_details', query: { id: item.id, type: 1}}" class="inline cl_violet">
								<img src="../../../static/video_voilet.png" v-show="item.video != ''" class="inline" />
								<span class="inline mal5">{{item.name}}</span>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import careerHeader from '../../components/career_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'treasury_major',
		components: {
			publicHeader,
			careerHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				careerNav: 2,	//导航
				majorCate: [],
				currenCate: 0,
				collegeList: [],
				currenCollege: 0,
				majorCont: [],
				
			}
		},
		mounted() {
			
		},
		created() {
			this.getUni();
			
		},
		methods: {
			//获取分类
			getUni () {
				var that = this;
				that.$get("/api/careerbible/get_major_cate_data",{})
				.then(res => {
					that.majorCate = res.data;
					that.getColl();
				});
			},
			//获取院系
			getColl () {
				var that = this;
				that.$get("/api/careerbible/get_major_cate_data",{
					major_cate_id: that.majorCate[that.currenCate].id
				})
				.then(res => {
					that.collegeList = res.data;
					that.getCont();
				});
			},
			//获取专业
			getCont () {
				var that = this;
				that.$get("/api/careerbible/get_major_list_data",{
					major_cate_id: that.collegeList[that.currenCollege].id
				})
				.then(res => {
					that.majorCont = res.data;
				});
			},
			
			uniCheck (e) {
				this.currenCate = e;
				this.getUni();
			},
			collCheck (e) {
				this.currenCollege = e;
				this.getColl();
			},
		},
	}
</script>

<style>
</style>
